// extracted by mini-css-extract-plugin
export default {"noBreadcrumbs":"GlobalNavBar-module__noBreadcrumbs--fKsj_"};